import styled from 'styled-components';
import { ReactComponent as Pix } from '../../../assets/icons/pix.svg';

export const QrCode = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  .description {
    font-weight: 400;
    font-size: 16px;
    line-height: 120%;
    color: ${(props) => props.theme.colors.black};
    margin-bottom: 28px;
  }
`;

export const IconPix = styled(Pix)`
  width: 28px;
  height: 28px;
  margin-right: 15px;

  @media screen and (max-width: 960px) {
    width: 36px;
    height: 36px;
  }
`;
export const Container = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
`;
export const Code = styled.div`
  margin: 20px 0 10px 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
`;
export const Value = styled.div`
  margin-top: 10px;
`;
export const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin: 20px 0;
`;
export const PixStringContainer = styled.div``;
export const PixCopyPaste = styled.div`
  display: flex;
  justify-content: center;
`;
export const Name = styled.div`
  margin-top: 15px;
`;
